import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dispatch } from 'd3-dispatch';

import widgetWrapper from './widgetWrapper';

import {
  formatValue,
  formatTimestamp,
  renderSparkline,
} from './widgetUtils';

import './SparklineWidget.scss';

class SparklineWidget extends Component {

  static propTypes = {
    // xAccessor: PropTypes.func,
    // yAccessor: PropTypes.func,
    // xDomain: PropTypes.arrayOf(PropTypes.number),
    // yDomain: PropTypes.arrayOf(PropTypes.number),
    // colorAccessor: PropTypes.func,
    // baseline: PropTypes.number,
    series: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.shape,
        value: PropTypes.number,
        auxValue: PropTypes.number,
      })),
      margin: PropTypes.shape({
        top: PropTypes.number,
        right: PropTypes.number,
        left: PropTypes.number,
        bottom: PropTypes.number,
      }),
      points: PropTypes.shape({
        color: PropTypes.string,
        radius: PropTypes.number,
      }),
      colors: PropTypes.arrayOf(PropTypes.string),
      strokeWidth: PropTypes.number,
    }),
    format: PropTypes.string,
    smallFormat: PropTypes.string,
    title: PropTypes.string,
    titleHasInnerHTML: PropTypes.bool,
    swatchColor: PropTypes.string,
    subtitle: PropTypes.string,
    details: PropTypes.string,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    auxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  static defaultProps = {
    series: null,
    format: '.3s',
    smallFormat: '.2f',
    title: '',
    subtitle: '',
    titleHasInnerHTML: false,
    swatchColor: null,
    details: '',
    timestamp: '',
    className: '',
    value: null,
    auxValue: null,
  };

  constructor(...args) {
    super(...args);
    this.doD3Rendering = renderSparkline.bind(this);
    this.chartRef = React.createRef();
    this.currPoint = null;
    this.dispatcher = dispatch('pointenter', 'pointleave');
    this.dispatcher.on('pointenter', ({ value = NaN, auxValue = NaN }) => {
      this.setState({
        hoverValue: value,
        hoverAuxValue: auxValue,
      });
    });
    this.dispatcher.on('pointleave', () => {
      this.setState({
        hoverValue: NaN,
        hoverAuxValue: NaN,
      });
    });
  }

  state = {
    hoverValue: NaN,
    hoverAuxValue: NaN,
  };

  componentDidMount() {
    window.addEventListener('resize', this.doD3Rendering);
    this.doD3Rendering();
  }

  componentDidUpdate(_prevProps, _prevState) {
    this.doD3Rendering();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.doD3Rendering);
  }

  render() {
    const {
      title,
      titleHasInnerHTML,
      swatchColor,
      subtitle,
      details,
      format,
      smallFormat,
      timestamp,
      className,
    } = this.props;
    let {
      value,
      auxValue,
    } = this.props;
    if (this.state.hoverValue) {
      value = this.state.hoverValue;
    }
    if (this.state.hoverAuxValue) {
      auxValue = this.state.hoverAuxValue;
    }
    return (
      <div className={`widget-threshold-colors SparklineWidget ${className}`}>
        <div className="header">
          <div className="top-row">
            { swatchColor ? <div className="swatch" style={{ color: swatchColor }}>&#9632;</div> : <div />}
            {
              titleHasInnerHTML
                ? <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
                : <div className="title">{title}</div>
            }
          </div>
          <div className="subtitle">{subtitle}</div>
        </div>
        <div className="content">
          <div className="content-wrapper">
            <div className="value">
              {
                typeof value === 'string'
                  ? value
                  : formatValue(value, format, smallFormat)
              }
            </div>
            <div className="aux-value">
              {
                // eslint-disable-next-line no-nested-ternary
                typeof auxValue === 'string'
                  ? auxValue
                  : Number.isNaN(auxValue) ? '' : auxValue
              }
            </div>
            <div className="sparkline-wrapper">
              <svg className="sparkline-svg" ref={this.chartRef} />
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="details">{details}</div>
          <div className="timestamp">{formatTimestamp(timestamp)}</div>
        </div>
      </div>
    );
  }
}

export default widgetWrapper(SparklineWidget);
